/* eslint-disable import/no-extraneous-dependencies */
import { rest } from 'msw';
import { Company } from '@/views/companies/interfaces';
import { filterByName, findById, mockServerApi, randomId } from '@/common/utils';
import { COMPANIES_LIST, COMPANY_GROUPS_LIST, COMPANY_STATS, BASE_COMPANY, DELETED_COMPANY_GROUP_LIST, USERS } from '../data';

export const companiesRequests = (msw: typeof rest) => [
  msw.get(mockServerApi('/companies'), (req, res, ctx) => {
    const deleted = req.url.searchParams.get('deleted');
    let response = COMPANIES_LIST.filter((n) => !n.deletedAt);

    if (deleted === 'only') {
      response = COMPANIES_LIST.filter((n) => n.deletedAt);
    }

    return res(
      ctx.status(200),
      ctx.json({
        items: response,
      }),
    );
  }),

  msw.post(mockServerApi('/companies'), (req: { body: { name: string } }, res, ctx) => {
    if (filterByName(COMPANIES_LIST, req.body.name).length === 0) {
      const company = {
        ...BASE_COMPANY,
        id: randomId(),
        name: req.body.name,
        lastLogin: 'N/A',
        licenses: [],
      };

      COMPANIES_LIST.push(company);

      return res(
        ctx.status(201),
        ctx.json(company),
      );
    }

    return res(
      ctx.status(409),
      ctx.json({ message: 'Company name already exists' }),
    );
  }),

  msw.get(mockServerApi('/companies/:id'), (req, res, ctx) => {
    const { id } = req.params;
    const companyData = findById(COMPANIES_LIST, id.toString());

    if (Object.keys(companyData).length === 0) {
      return res(ctx.status(401), ctx.json({ message: 'Company id is invalid' }));
    }

    return res(ctx.status(200), ctx.json(companyData));
  }),

  msw.delete(mockServerApi('/companies/:id'), (req, res, ctx) => res(
    ctx.status(204),
  )),

  msw.patch(mockServerApi('/companies/:id'), (req: { body: Company }, res, ctx) => {
    const newName = req.body.name;
    const currentIndex = COMPANIES_LIST.findIndex((company) => company.id === req.body.id);
    const currentCompanies = filterByName(COMPANIES_LIST, newName);

    if (currentCompanies.length === 1 && (currentCompanies[0].id !== req.body.id)) {
      return res(
        ctx.status(400),
        ctx.json({ message: 'Company name already exists' }),
      );
    }

    if (currentCompanies.length > 1) {
      return res(
        ctx.status(400),
        ctx.json({ message: 'Company name already exists' }),
      );
    }

    const updatedData = {
      ...req.body,
      createdAt: new Date(Date.now()).getTime(),
      updatedAt: new Date(Date.now()).getTime(),
      lastUsed: new Date(Date.now()).getTime(),
    };

    COMPANIES_LIST[currentIndex] = updatedData;

    return res(
      ctx.status(200),
      ctx.json(updatedData),
    );
  }),

  msw.get(mockServerApi('/companies/:id/stats'), (req, res, ctx) => res(
    ctx.status(200),
    ctx.json({
      stats: COMPANY_STATS,
    }),
  )),

  msw.get(mockServerApi('/companies/:id/users'), (req, res, ctx) => {
    const companyId = req.params.id;

    return res(
      ctx.status(200),
      ctx.json({
        items: USERS
          .filter((u) => {
            const userCompany = u.companies[0] as Partial<Company>;
            return userCompany.id === companyId;
          })
          .filter((u) => !u.deletedAt),
      }),
    );
  }),

  msw.get(mockServerApi('/companies/:id/groups'), (req, res, ctx) => {
    const { id } = req.params;
    const company = COMPANIES_LIST.find((c) => c.id === id);

    if (company.name.includes('Deleted')) {
      return res(
        ctx.status(200),
        ctx.json({
          items: DELETED_COMPANY_GROUP_LIST,
        }),
      );
    }

    if (id !== '123') {
      return res(
        ctx.status(200),
        ctx.json({
          items: [],
        }),
      );
    }
    return res(
      ctx.status(200),
      ctx.json({
        items: COMPANY_GROUPS_LIST,
      }),
    );
  }),

  msw.post(mockServerApi('/companies/:id/groups'), (req: { body: { name: string } }, res, ctx) => {
    const group = {
      id: randomId(),
      name: req.body.name,
      createdAt: new Date(Date.now()).getTime(),
      updatedAt: new Date(Date.now()).getTime(),
      users: [],
    };

    COMPANY_GROUPS_LIST.push(group);

    return res(
      ctx.status(200),
      ctx.json(group),
    );
  }),

  msw.post(mockServerApi('/companies/:id/restore'), (req, res, ctx) => {
    const { id } = req.params;
    const index = COMPANIES_LIST.findIndex((n) => n.id === id.toString());

    COMPANIES_LIST[index].deletedAt = null;

    return res(
      ctx.status(200),
      ctx.json({
        message: 'ok',
      }),
    );
  }),
];

export default companiesRequests;
